import Vue from 'vue'
import Router from 'vue-router'

import AboutPage from '@/components/AboutPage'
import Home from '@/components/Home'
import ListDetail from '@/components/ListDetail'
import CreateList from '@/components/CreateList'
import Login from '@/components/Login'
import Messages from '@/components/Messages'
import Profile from '@/components/Profile'
import Discover from '@/components/Discover'
import Register from '@/components/Register'
import Settings from '@/components/Settings'
import ResetPassword from '@/components/ResetPassword'
import ResetPasswordConfirm from '@/components/ResetPasswordConfirm'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/discover',
      name: 'discover',
      component: Discover,
    },
    {
      path: '/lists/:username',
      name: 'profile',
      component: Profile,
    },
    {
      path: '/list/:id',
      name: 'listdetail',
      component: ListDetail,
    },
    {
      path: '/create',
      name: 'create',
      component: CreateList,
    },
    {
      path: '/messages',
      name: 'messages',
      component: Messages
    },
    {
      path: '/about',
      name: 'about',
      component: AboutPage
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    },
    {
      path: '/reset-password',
      name: 'resetpassword',
      component: ResetPassword
    },
    {
      path: '/reset-password/:token',
      name: 'resetpasswordconfirm',
      component: ResetPasswordConfirm
    }
  ]
})
